import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Newsletter.css';

const Newsletter = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const handleSubmit = (e) => {
    e.preventDefault();
    alert(t('newsletter.success', 'Assinatura realizada com sucesso!'));
    setEmail('');
  };
  return (
    <section className="newsletter">
      <div className="container">
        <div className="newsletter-box" data-aos="fade-up">
          <div className="newsletter-text">
            <h2 className="newsletter-title">{t('newsletter.title', 'Receba novidades')}</h2>
            <p className="newsletter-description">{t('newsletter.description', 'Assine e receba novidades no seu e-mail.')}</p>
          </div>
          <form className="newsletter-form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder={t('newsletter.placeholder', 'Digite seu e-mail')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="newsletter-input"
            />
            <button type="submit" className="btn btn-purple">
              {t('newsletter.button', 'Inscrever-se')}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;


